<!-- Custom checkbox to be used as a single element
Example usage: sign up policy or password visibility toggle -->
<template>
   <div class="flex">
      <span>
         <input
            :id="id"
            type="checkbox"
            name="checkbox"
            :data-cy="id"
            class="cursor-pointer"
            :class="{ 'error-style': errorStyle }"
            :checked="modelValue"
            @change="updateValue(($event.target as HTMLInputElement).checked)"
         />
      </span>
      <label v-if="label && !hideLabel" :for="id" class="ml-2 cursor-pointer">
         {{ label }}
      </label>
   </div>
</template>

<script setup lang="ts">
import { slugify } from "@/js/helpers/slugify";

const emits = defineEmits(["update:modelValue"]);

const props = defineProps<{
   label: string;
   hideLabel?: boolean;
   errorStyle?: boolean;
   modelValue?: boolean;
}>();

const id = computed(() => slugify(props.label));

function updateValue(value: boolean) {
   emits("update:modelValue", value);
}
</script>

<style lang="css" scoped>
/*
  Learn about this technique:
  @link https://moderncss.dev/pure-css-custom-checkbox-style/
*/

input[type="checkbox"] {
   /* Add if not using autoprefixer */
   -webkit-appearance: none;
   /* Remove most all native input styles */
   appearance: none;
   margin: 0;
   font: inherit;
   color: currentColor;
   width: 22px;
   height: 22px;
   border-radius: 6px;
   /* background-color: #193e72; */
   display: grid;
   place-content: center;
   border: solid 1px var(--colour-border-base);
   @apply bg-white focus:border-brand-dark;
}

input.error-style {
   border-color: var(--colour-danger-hover);
}

input[type="checkbox"]:checked {
   @apply bg-brand-dark;
}

input[type="checkbox"]::before {
   content: "";
   width: 10.5px;
   height: 7.65px;
   transform: scale(0);
   background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.025 0.399805C10.725 0.0998047 10.275 0.0998047 9.975 0.399805L4.35 6.02481L2.025 3.69981C1.725 3.39981 1.275 3.39981 0.975 3.69981C0.675 3.99981 0.675 4.44981 0.975 4.74981L3.825 7.5998C3.975 7.7498 4.125 7.82481 4.35 7.82481C4.575 7.82481 4.725 7.7498 4.875 7.5998L11.025 1.44981C11.325 1.14981 11.325 0.699805 11.025 0.399805Z' fill='white'/%3E%3C/svg%3E");
}

input[type="checkbox"]:checked::before {
   transform: scale(1);
}

input[type="checkbox"]:focus {
   outline-offset: max(1px, 0.08em);
   outline: auto;
}

input[type="checkbox"]:disabled {
   cursor: not-allowed;
}
</style>
